import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, createVNode as _createVNode, withCtx as _withCtx, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "w-full max-w-[1113px] min-w-[328px]" }
const _hoisted_2 = { class: "flex flex-col items-center w-full" }
const _hoisted_3 = { class: "self-start pt-12 pb-8 text-2xl font-medium" }
const _hoisted_4 = {
  key: 0,
  class: "flex flex-col items-center w-full md:px-0"
}
const _hoisted_5 = { class: "flex justify-center w-full" }
const _hoisted_6 = { class: "text-xl !font-medium text-black" }
const _hoisted_7 = { class: "p-4" }
const _hoisted_8 = { class: "mb-6 text-base font-semibold text-neutral-900" }
const _hoisted_9 = { class: "flex flex-col content-center gap-[14px]" }
const _hoisted_10 = ["for"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_CommentCard = _resolveComponent("CommentCard")!
  const _component_Paginator = _resolveComponent("Paginator")!
  const _component_RadioButton = _resolveComponent("RadioButton")!
  const _component_Button = _resolveComponent("Button")!
  const _component_Dialog = _resolveComponent("Dialog")!
  const _component_ConfirmDialog = _resolveComponent("ConfirmDialog")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("section", _hoisted_2, [
      _createElementVNode("h4", _hoisted_3, _toDisplayString(_ctx.$t("forum.topic.details.listComments.title")), 1)
    ]),
    (_ctx.totalComments > 0)
      ? (_openBlock(), _createElementBlock("section", _hoisted_4, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.comments, (comment) => {
            return (_openBlock(), _createBlock(_component_CommentCard, {
              comment: comment,
              topic: _ctx.topic,
              key: comment.id,
              onDeleteComment: _ctx.deleteComment,
              onReplyComment: _ctx.replyComment,
              onCommentId: _ctx.commentSelectedId,
              onIsDenounceDialogVisible: _cache[0] || (_cache[0] = ($event: any) => (_ctx.isDenounceDialogVisible(true))),
              class: "mb-6"
            }, null, 8, ["comment", "topic", "onDeleteComment", "onReplyComment", "onCommentId"]))
          }), 128)),
          _createVNode(_component_Paginator, {
            totalRecords: _ctx.totalComments,
            rows: _ctx.numberOfCommentsPerPage,
            value: _ctx.comments,
            first: _ctx.getFirstItemIndexActualPage(),
            onPage: _ctx.onPaginate,
            pageLinkSize: 3,
            class: "justify-center mb-16 md:flex md:w-full w-fit md:justify-end custom-paginator-forum"
          }, null, 8, ["totalRecords", "rows", "value", "first", "onPage"]),
          _createVNode(_component_Dialog, {
            group: "denouncingComment",
            visible: _ctx.denounceDialogVisible,
            "onUpdate:visible": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.denounceDialogVisible) = $event)),
            style: { maxWidth: '540px' },
            class: "w-11/12 custom-dialogForum",
            modal: true
          }, {
            header: _withCtx(() => [
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("h2", _hoisted_6, _toDisplayString(_ctx.$t("labels.generic", {
                  pt: "Denunciar comentário",
                  en: "Report comment",
                })), 1)
              ])
            ]),
            footer: _withCtx(() => [
              _createVNode(_component_Button, {
                label: "Cancelar",
                text: "",
                severity: "secondary",
                autofocus: "",
                onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.isDenounceDialogVisible(false))),
                class: "h-8 btn-outline"
              }),
              _createVNode(_component_Button, {
                label: "Enviar denúncia",
                outlined: "",
                severity: "secondary",
                autofocus: "",
                onClick: _ctx.reportComment,
                class: "h-8 py-4 btn-primary",
                disabled: _ctx.isDenounceButtonDisabled
              }, null, 8, ["onClick", "disabled"])
            ]),
            default: _withCtx(() => [
              _createElementVNode("div", null, [
                _createElementVNode("div", _hoisted_7, [
                  _createElementVNode("p", _hoisted_8, _toDisplayString(_ctx.$t("labels.generic",{
                  pt: "Agradecemos por ajudar a manter nossa comunidade segura e acolhedora. Por favor, selecione o motivo da sua denúncia: ",
                  en: "Thank you for helping to keep our community safe and welcoming. Please select the reason for your denounce: ",
                })), 1),
                  _createElementVNode("div", _hoisted_9, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.denounceComment, (denounce) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: denounce.key,
                        class: "flex items-baseline align-items-center text-neutral-900"
                      }, [
                        _createVNode(_component_RadioButton, {
                          modelValue: _ctx.descriptionDenounce,
                          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.descriptionDenounce) = $event)),
                          inputId: denounce.key,
                          name: "dynamic",
                          value: _ctx.$t('labels.generic', {pt: denounce.labelPT, en: denounce.labelEN})
                        }, null, 8, ["modelValue", "inputId", "value"]),
                        _createElementVNode("label", {
                          for: denounce.key,
                          class: "ml-2 text-base font-medium font-mulish"
                        }, _toDisplayString(_ctx.$t("labels.generic", { pt: denounce.labelPT, en: denounce.labelEN })), 9, _hoisted_10)
                      ]))
                    }), 128))
                  ])
                ])
              ])
            ]),
            _: 1
          }, 8, ["visible"])
        ]))
      : _createCommentVNode("", true),
    _createVNode(_component_ConfirmDialog, {
      group: "deletingComment",
      style: { maxWidth: '490px' },
      class: "w-11/12 custom-confirm-dialog"
    })
  ]))
}